// 55吃瓜 - 金句、表情包、专题、FAQ、口碑等数据

export interface Featured {
  id: number;
  tag: string;
  title: string;
  desc: string;
  image: string;
  readTime: string;
  points: string[];
}

export interface Meme {
  id: number;
  src: string;
  caption: string;
}

export interface Faq {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const tickerTags: string[] = [
  "#图书馆喊哥哥娶我",
  "#给老板唱生日歌唱错人",
  "#自助餐扶墙进",
  "#手滑发给现对象",
  "#丑照被做成挂历",
  "#卸载游戏又回来",
  "#工作群发错消息",
  "#相亲吐槽到闺蜜",
  "#社死名场面",
];

export const featured: Featured[] = [
  {
    id: 1,
    tag: "年度盘点",
    title: "2026 上半年·最离谱的十大社死名场面",
    desc: "从电梯认错人到把公司群当相亲群，我们按‘尬到脚趾抠地’的强度，为你整理出今年上半年杀伤力最猛的名场面，每一页都值得反复观看。",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20collage%20of%20funny%20embarrassing%20daily%20life%20moments%20in%20a%20newspaper%20tabloid%20style%2C%20warm%20cream%20background%2C%20coral%20lime%20and%20mustard%20accents%2C%20no%20text&width=1200&height=700&seq=featured-01&orientation=landscape",
    readTime: "8 分钟",
    points: [
      "把闺蜜的婚礼致辞背成了别人的名字",
      "在公司楼下保安大叔面前表演了老板的车钥匙",
      "外卖备注‘不要香菜’结果老板名字就叫香菜",
    ],
  },
  {
    id: 2,
    tag: "职场图鉴",
    title: "职场‘甩锅侠’图鉴：老板口中的外包到底背了多少锅",
    desc: "本期深度吐槽打工生态：开会三分钟，甩锅两小时。我们走进写字楼，围观那些‘问题不大，先怪上周同事’的名场面。",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20office%20colleagues%20pointing%20fingers%20and%20passing%20a%20giant%20hot%20pot%20pan%20around%20a%20meeting%20table%2C%20funny%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=1200&height=700&seq=featured-02&orientation=landscape",
    readTime: "6 分钟",
    points: [
      "凌晨改的需求，白天秒变‘这是我提的优化’",
      "同事甩锅文案比工作报告写得还流畅",
      "加班是福报，福报是替领导把年假都加完",
    ],
  },
  {
    id: 3,
    tag: "生活观察",
    title: "当代年轻人的‘干饭仪式感’：先拍后吃是基本素养",
    desc: "为什么吃之前一定要让手机先吃？我们研究了当代干饭人的完整流程：摆盘、打光、找角度、调滤镜，最后才舍得动筷子。",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20young%20person%20taking%20a%20photo%20of%20a%20colorful%20meal%20with%20a%20phone%20before%20eating%2C%20funny%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=1200&height=700&seq=featured-03&orientation=landscape",
    readTime: "5 分钟",
    points: [
      "菜可以凉，氛围感不能少",
      "吃之前手机先消毒，简称‘机洗’",
      "一顿饭拍四十分钟，吃十分钟，P 图一小时",
    ],
  },
];

export const quotes: string[] = [
  "人生没有白走的路，每一步都是社死的伏笔。",
  "我本来可以靠才华吃饭，可惜我的才华也只会吃饭。",
  "成年人的崩溃，往往是从手机没电却找不到充电线开始的。",
  "上班叫还债，下班叫续命，周末叫回光返照。",
  "我不是懒，我只是在给未来的自己放个假。",
  "只要我甩锅甩得够快，领导的怒火就追不上我。",
  "减肥最好的方法，是让钱包先瘦下去。",
  "小时候以为长大很自由，长大后发现自由的尽头是周一的闹钟。",
  "我的人生像自助餐，看似选择很多，其实能回本的很少。",
  "别跟我谈理想，我的理想是不上班。",
];

export const memes: Meme[] = [
  {
    id: 1,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20face%20of%20a%20surprised%20cat%20with%20huge%20eyes%20and%20open%20mouth%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-01&orientation=squarish",
    caption: "我 刚 说 了 什 么",
  },
  {
    id: 2,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20an%20exhausted%20dog%20wearing%20a%20tie%20lying%20flat%20on%20a%20desk%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-02&orientation=squarish",
    caption: "周 一 的 我 被 掏 空",
  },
  {
    id: 3,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20smug%20smiling%20fox%20winking%20with%20arms%20crossed%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-03&orientation=squarish",
    caption: "就 这 ？就 这 ？",
  },
  {
    id: 4,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20crying%20but%20internally%20laughing%20panda%20wiping%20a%20tear%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-04&orientation=squarish",
    caption: "笑 中 带 泪 的 我",
  },
  {
    id: 5,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20furious%20rabid%20duck%20stomping%20a%20foot%20and%20pointing%20accusingly%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-05&orientation=squarish",
    caption: "你 再 说 一 遍",
  },
  {
    id: 6,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20dizzy%20round%20bird%20spinning%20with%20confused%20eyes%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-06&orientation=squarish",
    caption: "我 在 哪 我 是 谁",
  },
  {
    id: 7,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20happy%20cheerful%20rabbit%20jumping%20with%20confetti%20around%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-07&orientation=squarish",
    caption: "又 可 以 吃 瓜 了",
  },
  {
    id: 8,
    src: "https://readdy.ai/api/search-image?query=cartoon%20meme%20of%20a%20cool%20duck%20wearing%20sunglasses%20listening%20to%20gossip%20with%20an%20ear%20cupped%2C%20flat%20sticker%20style%2C%20warm%20cream%20background%2C%20no%20text&width=520&height=520&seq=meme-08&orientation=squarish",
    caption: "细 说 细 说 我 在 听",
  },
];

export const faqs: Faq[] = [
  {
    q: "55吃瓜 的内容都是真实的吗？",
    a: "平台内容以网友投稿和趣味创作演绎为主，很多故事经过了艺术化加工。我们始终标注‘吐槽/演绎’属性，仅供娱乐解压，不建议把里面的剧情当成新闻或事实看待。",
  },
  {
    q: "我的一段社死经历也能投稿吗？",
    a: "当然可以！欢迎在页面底部的‘吐槽投稿’区域填写你的名场面。我们会筛选有趣、不涉及隐私与人身攻击的稿子，整理成图文，让更多朋友一起围观（并在结尾为你默哀三秒）。",
  },
  {
    q: "表情包可以直接保存使用吗？",
    a: "本站表情包为编辑创作或共享素材，可自由保存用于日常聊天。用于商业用途时请自行确认素材版权，建议标注来源。",
  },
  {
    q: "为什么叫‘吃瓜’，却讲的全是社死和吐槽？",
    a: "‘吃瓜’本意是围观热闹，而围观别人‘翻车现场’正是最快乐的吃瓜姿势。我们只吃自己挖的瓜，把大家的离谱日常做成年更爽剧。",
  },
  {
    q: "内容多久更新一次？",
    a: "每日滚动上新热梗，每周三更新深度专题‘吐槽特辑’。你可以常回来看看，或者把喜欢的栏目收藏起来，防止错过新鲜瓜。",
  },
  {
    q: "看到让我很不适或涉及隐私的内容怎么办？",
    a: "如果某篇内容涉及你的真实隐私或让你感到不适，欢迎通过投稿区域的联系方式告知我们，核实后我们会第一时间做脱敏或下架处理。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "@不务正业",
    role: "打工人",
    text: "笑点低的人真的别在通勤路上刷，差点在地铁里笑出声被当成神经病。",
  },
  {
    name: "@深夜emo选手",
    role: "学生党",
    text: "本来emo了一晚上，看完那个丑照挂历的瓜，直接笑到肚子疼，什么烦恼都没了。",
  },
  {
    name: "@摸鱼达人",
    role: "办公室常驻",
    text: "每天午休必来扒拉两眼，金句我甚至能背下来怼同事，战斗力直接拉满。",
  },
];

export const stats: { value: string; label: string }[] = [
  { value: "8600+", label: "条沙雕爆梗" },
  { value: "12w+", label: "表情包下载" },
  { value: "3100+", label: "位投稿吐槽主" },
  { value: "99%", label: "的网友笑到肚子疼" },
];